import { useUser } from '../context/UserContext';
import { useFeatureContext } from '../context/FeatureContext';
import { useFeatureModal } from '../context/FeatureModalContext';
import { IInAppNotification } from '../interface';
import { useNotificationRedirection } from './useNotificationRedirection';
import { useMarkAllNotifications } from './useMarkAllNotifications';
import { useNotificationTemplateConfig, useNotificationAccessGating } from './notificationHandlers';

export const useNotificationActions = (onClose: () => void, refetch: () => void) => {
  const { user } = useUser();
  const { features } = useFeatureContext();
  const { showFeatureModal, showRestrictedUserModal } = useFeatureModal();

  const { redirect } = useNotificationRedirection(onClose);
  const { handleMarkAllAsRead } = useMarkAllNotifications(refetch);

  const notificationTemplateConfig = useNotificationTemplateConfig();
  const { checkAccessAndProceed } = useNotificationAccessGating(
    user,
    features,
    showFeatureModal,
    showRestrictedUserModal,
  );

  const handleNotificationRedirection = (notification: IInAppNotification) => {
    const config = notificationTemplateConfig[notification?.template?.identifier];
    if (config) {
      redirect(notification, config);
    }
  };

  const handleNotificationClick = (notification: IInAppNotification) => {
    const template = notification?.template?.identifier;
    const config = notificationTemplateConfig[template];

    if (!config) {
      return;
    }

    checkAccessAndProceed(config, notification, () => handleNotificationRedirection(notification));
  };

  return {
    handleNotificationClick,
    handleMarkAllAsRead,
  };
};
